var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHornActiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7568359,6c-0.8300781,0-1.5908203,0.4609375-1.9863281,1.2026367C26.0341797,10.453125,24.2792969,12,19,12h-7v-1 c0-1.6542969-1.3457031-3-3-3H3c-1.6542969,0-3,1.3457031-3,3v10c0,1.6542969,1.3457031,3,3,3h6c1.6542969,0,3-1.3457031,3-3v-1h7 c5.2792969,0,7.0341797,1.546875,8.7695312,4.796875C28.1660156,25.5390625,28.9267578,26,29.7568359,26 C30.9941406,26,32,24.9936523,32,23.7568359V8.2431641C32,7.0063477,30.9941406,6,29.7568359,6z M10,21c0,0.5512695-0.4482422,1-1,1 H3c-0.5517578,0-1-0.4487305-1-1V11c0-0.5512695,0.4482422-1,1-1h6c0.5517578,0,1,0.4487305,1,1V21z M30,23.7568359 c0,0.2246094-0.3466797,0.3222656-0.4658203,0.0981445C27.5537109,20.1469727,25.1953125,18,19,18h-7v-4h7 c6.1953125,0,8.5537109-2.1469727,10.5351562-5.8554688C29.6513672,7.9223633,30,8.0185547,30,8.2431641V23.7568359z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHornActiveSmall);
export default __webpack_public_path__ + "static/media/horn-active--small.47f448c0bb4525a6bb53a485a8ce8929.svg";
export { ForwardRef as ReactComponent };